class Testimonials {
    constructor() {
        this.state = {
            appKey: testimonialsReview.appKey,
            template: testimonialsReview.template,
            type: testimonialsReview.type,
            product: testimonialsReview.product,
            productList: testimonialsReview.productList,
            sliderBreakpoints: testimonialsReview.sliderBreakpoints,
            limit: testimonialsReview.limit,
            textContent: testimonialsReview.textContent,
            templateName: testimonialsReview.templateName
        }

        this.selectors = {
            section: ".shopify-section.testimonials",
            wrapper: this.state.template === "slider" ? '.testimonials-slider-wrapper' : '.testimonials-grid-wrapper',
            slider: this.state.template === "slider" ? '.testimonials-slider' : '.testimonials-grid',
            container: this.state.template === "slider" ? ".testimonials-slider-container" : '.testimonials-grid-container',
            showMoreBtn: '.show-more-reviews--wrapper',
            hiddenCards: '.review_item.hidden',
            reviewWidget: ".yotpo-widget-instance"
        }

        this.elements = {
            sectionElement: document.querySelector(this.selectors.section),
            wrapperElement: document.querySelector(this.selectors.wrapper),
            containerElement: document.querySelector(this.selectors.container),
            showMoreBtnElement: document.querySelector(this.selectors.showMoreBtn),
            reviewWidgetElement: document.querySelector(this.selectors.reviewWidget)
        }
        
        this.modifiers = {
            hiddenCard: "hidden",
            hiddenSection: "hidden-section"
        }

        this.isLoadMore = false;
        this.reviews = [];
        this.loadMoreReviews = [];
        this.maxRequstedReviews = 0;
        this.pages = 1;
        this.visibleReviews = 0;

    }
    async init() {
        this.pages =  Math.ceil(this.state.limit / 5);
        this.initListeners();
        switch (this.state.type) {
            case 'all':
                for (let page = 1; page <= this.pages; page++) {
                    await this.getAllReviews(page);
                }
                break;
            case 'current_product':
                for (let page = 1; page <= this.pages; page++) {
                    await this.getSingleProduct(this.state.product, page);
                }
                break;
            case 'single_product':
                for (let page = 1; page <= this.pages; page++) {
                    await this.getSingleProduct(this.state.product, page);
                }
                break;
            case 'product_list':
                this.state.productList.forEach(async (id)=>{
                    for (let page = 1; page <= this.pages; page++) {
                        await this.getSingleProduct(id, page);
                    }
                })
                break;
        }
        this.renderCards()
        if (this.state.template === 'slider') {
            this.initSlider();
        }
    }

    initListeners() {
        if (this.state.template === 'grid' && this.elements.showMoreBtnElement) {
            this.elements.showMoreBtnElement.addEventListener("click", ()=>this.loadMore())
        }
    }

    async getSingleProduct(productId, page) {
        const productReviewsApiUrl = `https://api.yotpo.com/v1/widget/${this.state.appKey}/products/${productId}/reviews?page=${page}`;
        await fetch(productReviewsApiUrl)
            .then(response => response.json())
            .then((data) => {
                this.maxRequstedReviews = data.response.pagination.total;
                if (!this.isLoadMore) {
                    this.reviews.push(...data.response.reviews);
                } else {
                    this.loadMoreReviews.push(...data.response.reviews)
                }
                
                return true
            })
            .catch(error => {
                console.error(error);
                return false
            });
    }

    async getAllReviews(page) {
        const AllReviewsApiUrl = `https://api.yotpo.com/v1/widget/${this.state.appKey}/reviews?page=${page}`;
        
        await fetch(AllReviewsApiUrl)
            .then(response => response.json())
            .then(data => {
                this.maxRequstedReviews = data.response.pagination.total;
                if (!this.isLoadMore) {
                    this.reviews.push(...data.response.reviews);
                } else {
                    this.loadMoreReviews.push(...data.response.reviews)
                }
                return true
            })
            .catch(error => {
                console.error(error);
                return false
            });
    }

    initSlider() {
        const slider = document.querySelector(this.selectors.slider)
        let swiper = new window.swiper(slider, {
            slidesPerView: 1,
            autoHeight: true,
            loop: true,
            pagination: {
                el: '.testimonials-swiper-pagination.swiper-pagination',
                clickable: true
            },
            breakpoints: this.state.sliderBreakpoints
        });
    }

    async loadMore(){
        this.isLoadMore = true;
        const page = this.pages + 1;
        const hiddenCards = document.querySelectorAll(this.selectors.hiddenCards);
        if (hiddenCards.length) {
            hiddenCards.forEach(card=>{
                card.classList.remove(this.modifiers.hiddenCard)
                this.visibleReviews++
            })
        }
        switch (this.state.type) {
            case 'all':
                await this.getAllReviews(page);
                break;
            case 'current_product':
                await this.getSingleProduct(this.state.product, page);
                break;
            case 'single_product':
                await this.getSingleProduct(this.state.product, page);
                break;
            case 'product_list':
                this.state.productList.forEach(async (id)=>{
                    await this.getSingleProduct(id, page);
                })
                break;
            }
            this.renderCards();
    }

    renderCards() {
        let className = ""
        const renderingReviews = this.isLoadMore ? this.loadMoreReviews : this.reviews;
        if (renderingReviews.length > 0) {
            if (this.elements.sectionElement && this.elements.sectionElement.classList.contains(this.modifiers.hiddenSection)) {
                this.elements.sectionElement.classList.remove(this.modifiers.hiddenSection)
            }
            renderingReviews.forEach((review, index) => {
                if (index < this.state.limit && this.state.template === "slider") {
                    this.createCard(review, className)
                    return
                }
                if (this.state.template === "grid") {
                    if (index >= this.state.limit) {
                        className = this.modifiers.hiddenCard;
                    }
                    this.createCard(review, className)
                }
            })
        }

        if (this.elements.showMoreBtnElement) {
            if (this.visibleReviews < this.maxRequstedReviews) {
                this.elements.showMoreBtnElement.classList.remove(this.modifiers.hiddenCard)
            } else {
                this.elements.showMoreBtnElement.classList.add(this.modifiers.hiddenCard)
            }
        }
        
    }

    createCard(review, className) {
        if (!className.length) {
            this.visibleReviews++
        }
        const userName = review.user.display_name;
        let userType = review.user.user_type;
        const description = review.content;
        const starRating = review.score;
        const starsWidget = this.createStarRating(starRating);
        const verifiedLabel = this.state.textContent.verified;

        const customerPosition = this.state.textContent.settings.show_customer_position ? `<div class="position">${userType}</div>` : '';
        const verifiedElement = this.state.textContent.settings.show_verified_label ? `<div class="subtitle">${verifiedLabel}</div>` : '';

        const reviewBlock = `<div class="${this.state.template === 'slider' ? 'swiper-slide' : 'grid-item'} review_item ${className}">
                                    <div class="name">
                                        ${userName}
                                    </div>
                                    ${customerPosition}
                                    <div class="review">
                                        <p>${description}</p>
                                    </div>
                                    <div class="stars">   
                                        ${starsWidget}
                                    </div>  
                                    ${verifiedElement}
                            </div>`
        
        this.elements.containerElement.innerHTML = this.elements.containerElement.innerHTML + reviewBlock
    }

    createStarRating(starRating) {
        let starts = "";

        const emptyStar = `<span class="star star--empty">
                            <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" width="14" height="14">
                                <defs>
                                    <linearGradient id="yotpo_stars_gradient_0.583717426505842">
                                        <stop offset="0%" stop-color="rgba(255,176,52,1)"></stop>
                                        <stop stop-opacity="1" offset="0%" stop-color="#FFFFFF"></stop>
                                    </linearGradient>
                                </defs>
                                <path d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(255,176,52,1)" fill="url('#yotpo_stars_gradient_0.583717426505842')"></path>
                            </svg>
                        </span>`

        const fullStar = `<span class="star star--full">
                            <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" width="14" height="14">
                                <defs>
                                    <linearGradient id="yotpo_stars_gradient_0.8064633490641004">
                                        <stop offset="100%" stop-color="rgba(255,176,52,1)"></stop>
                                        <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
                                    </linearGradient>
                                </defs>
                                <path d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(255,176,52,1)" fill="url('#yotpo_stars_gradient_0.8064633490641004')"></path>
                            </svg>
                        </span>`

        for( let i = 1; i <= 5; i++){
            if (i <= starRating) {
                starts += fullStar
            } else {
                starts += emptyStar
            }
        }

        let starts_wrapper = `<span class="yotpo-stars">${starts}</span>`;
        let stars_widget = `<div class="yotpo-display-wrapper" >  
                                <div class="standalone-bottomline" data-source="default" tabindex="-1"> 
                                    <div class="yotpo-bottomline pull-left  star-clickable" tabindex="0">  
                                    ${starts_wrapper} 
                                    <span  class="text-m" aria-label="${starRating} reviews" tabindex="-1">${starRating}.0</span>   
                                    <div class="yotpo-clr"></div> 
                                </div> 
                            <div class="yotpo-clr"></div> 
                            </div>   
                        <div class="yotpo-clr"></div> 
                    </div>`
        return stars_widget;
    }
}

document.addEventListener('DOMContentLoaded', ()=>{
    const testimonial = new Testimonials()
    testimonial.init()
})
